import { render, staticRenderFns } from "./sortDown.vue?vue&type=template&id=025619e0&"
import script from "./sortDown.vue?vue&type=script&lang=js&"
export * from "./sortDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports